import React from "react";
import SignUp from "../SignUp";

function SignUpPage() {
  return (
    <div>
      <SignUp />
    </div>
  );
}

export default SignUpPage;
